import { useEffect, useState } from 'react'

export const useObjectURL = input => {
  const [url, setUrl] = useState(null)

  useEffect(() => {
    if (!input) {
      setUrl(null)
      return
    }
    const objectUrl = URL.createObjectURL(input)
    setUrl(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [input])

  return url
}

export const createObjectURLWithCleanup = input => {
  const url = URL.createObjectURL(input)
  const revoke = () => URL.revokeObjectURL(url)
  return { url, revoke }
}
